module.exports = __webpack_public_path__ + "img/00001.8a8c62f9.webp";